<template>
  <div
    :class="{
      'open--positions-modal': true,
      'modal-mask': openPositionsModal.openAsModal
    }"
  >
    <div ref="modalContainer" v-on-click-outside="openPositionsModal.setCloseViewAll">
      <div>
        <section v-if="!openPositionsModal.layoutIsFullList">
          <OpenPositionsPreviewFilters />
        </section>
        <section v-else>
          <OpenPositionsFullFilters>
            <template #close>
              <span v-if="openPositionsModal.openAsModal" class="d-flex justify-content-end">
                <button
                  class="btn pe-0"
                  style="padding: 10px"
                  @click="openPositionsModal.setCloseViewAll()"
                  aria-label="Close Modal"
                >
                  <IconX />
                </button>
              </span>
            </template>
          </OpenPositionsFullFilters>
        </section>
        <div v-if="!loadStore.getLoadingState">
          <div
            v-if="openPositionsModal.isGrid"
            :class="`open--positions-modal__grid ${openPositionsModal.layoutIsFullList ? 'overflow-auto' : ''}`"
          >
            <OpenPositionsCard
              v-for="item in openPositionsModal.items"
              :key="item.id"
              :item="item"
              :locations="locations"
            />
          </div>

          <div v-else class="open-positions-modal__table">
            <OpenPositionsModalTable />
          </div>
          <div class="open--positions-modal__pager-wrapper">
            <div class="open--positions-modal-pager">
              <Pager
                v-if="
                  openPositionsModal.layoutIsFullList &&
                  openPositionsModal.openAsModal &&
                  openPositionsModal.items.length < openPositionsModal.totalResults
                "
              />
            </div>
            <div
              v-if="
                openPositionsModal.layoutIsFullList &&
                openPositionsModal.openAsModal &&
                openPositionsModal.items.length < openPositionsModal.totalResults
              "
              class="open--positions-modal-selection"
            >
              <label for="results-size" class="open--positions-modal__label" id="results-size-label">
                Results
                <select
                  id="results-size"
                  v-model="openPositionsModal.size"
                  class="form-select open--positions-size-select"
                  aria-labelledby="results-size-label"
                  aria-describedby="results-size-label"
                >
                  <option v-for="size in [8, 12, 16, 20]" :key="size" :value="size">{{
                    size
                  }}</option>
                </select>
              </label>
            </div>
          </div>
          <button
            v-if="
              openPositionsModal.layoutIsFullList &&
              openPositionsModal.items?.length < openPositionsModal.totalResults &&
              !openPositionsModal.openAsModal
            "
            @click="openPositionsModal.setReadMore(true)"
          >
            Read More...
          </button>
        </div>
        <div v-else>
          <div
            :class="{
              'open--positions-modal__grid': true,
              'd-grid overflow-auto full-list': openPositionsModal.layoutIsFullList,
              '-preview': !openPositionsModal.layoutIsFullList
            }"
          >
            <PlaceholderOpenPositionsCard />
            <PlaceholderOpenPositionsCard />
            <PlaceholderOpenPositionsCard />
            <PlaceholderOpenPositionsCard />
            <PlaceholderOpenPositionsCard />
            <PlaceholderOpenPositionsCard />
            <PlaceholderOpenPositionsCard />
            <PlaceholderOpenPositionsCard />
            <PlaceholderOpenPositionsCard />
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script setup lang="ts">
import { useOpenPositionModal } from '~/stores/modals/open-position-modal'
import { vOnClickOutside } from '@vueuse/components'
import { useWindowScroll } from '@vueuse/core'
import delay from 'lodash/delay'
import { type LocationPageModel } from '~/models'

const loadStore = useLoadingStore()
const openPositionsModal = useOpenPositionModal()
const locationStore = useLocationStore()

const modalContainer = ref<HTMLElement | null>()
const { y: scrollY } = useWindowScroll()
const lastWindowScroll = ref(0)
const locations = ref<LocationPageModel[] | undefined>([])

const showModal = () => {
  document.body.classList.add('modal-open')
  modalContainer.value?.classList.add('modal-container')
  delay(() => modalContainer.value?.classList.add('show'), 100)
  lastWindowScroll.value = scrollY.value
}

const hideModal = () => {
  document.body.classList.remove('modal-open')
  modalContainer.value?.classList.remove('modal-container')
  modalContainer.value?.classList.remove('show')
  window.scrollTo({
    top: lastWindowScroll.value,
    behavior: 'instant'
  })
}

locations.value = await locationStore.getLocations()

watch(
  () => openPositionsModal.openAsModal,
  (isOpenAsModal) => {
    if (isOpenAsModal) {
      showModal()
    } else {
      hideModal()
    }
  }
)
onUnmounted(() => hideModal())
</script>
